import React from 'react';
import PropTypes from 'prop-types';

// Import utilities
import { ToggleRPC, Portal } from 'components/utilities';

// Import styles
import {
	Wrapper,
	Bg,
	GradientBoxStyled,
	BoxStyled,
	GradientRadialStyled,
	ContentStyled,
	ButtonClose,
	IconCloseStyled
} from './styles';

function PaymentAlertTemplate({ children, onClose, initial, modalHeight }) {
	const handleClose = (toggle) => {
		toggle();

		onClose();
	};

	return (
		<ToggleRPC initial={initial}>
			{({ on, toggle }) => (
				<>
					{on && (
						<Portal>
							<Wrapper className="wrapper">
								<Bg />
								<GradientBoxStyled
									className="gradient"
									modalHeight={modalHeight}
								>
									<BoxStyled className="content-box">
										<ButtonClose onClick={() => handleClose(toggle)}>
											<IconCloseStyled />
										</ButtonClose>
										<GradientRadialStyled />
										<ContentStyled className="CONTENT">
											{children({ on, toggle })}
										</ContentStyled>
									</BoxStyled>
								</GradientBoxStyled>
							</Wrapper>
						</Portal>
					)}
				</>
			)}
		</ToggleRPC>
	);
}

PaymentAlertTemplate.defaultProps = {
	initial: false,
	modalHeight: null,
	onClose: () => {}
};

PaymentAlertTemplate.propTypes = {
	children: PropTypes.func.isRequired,
	onClose: PropTypes.func,
	initial: PropTypes.bool.isRequired,
	modalHeight: PropTypes.number
};

export default PaymentAlertTemplate;
